<template>
  <!-- BaseUpload为公司组件库的同版本源码, 本vue文件负责涉及业务部分的二次封装 -->
  <!-- 使用api请阅读el-input,拥有相同全套api -->
  <div v-if="show" class="zsUpload">
    <template v-if="!isDisabled">
      <zl-upload
        v-if="!isDisabled"
        ref="baseUpload"
        :http-request="uploadFile"
        v-bind="attrsCopy"
        :drag="drag"
        :multiple="multiple"
        :limit="isNeedFuGai ? 0 : limit"
        :before-upload="beforeUpload"
        :on-exceed="handleExceed"
        v-on="$listeners"
        :accept="fileTypes"
        :file-list="fileList"
        :show-file-list="false"
        :on-preview="handlePreview"
        :on-change="handleChange"
        :on-remove="handleRemove"
      />
      <div v-if="isNeedAccetpText" class="acceptMsg">允许上传格式：{{showFileTypesData}}</div>
      <div v-if="progressFlag" class="file-panel">
        <div style="display: flex;">
          <span class="uploading-icon"></span>
          <p>
            <span><i class="el-icon-document"></i></span>
            <el-tooltip class="item" effect="dark" :content="fileName" placement="top-start">
              <span class="fileName">{{ fileName }}</span>
            </el-tooltip>
            <span class="fileTime">{{ '上传中...' + progressPercent + '%' }}</span>
            <span class="progressBar"></span>
            <span class="progressBarMove" :style="{ 'width': progressPercent + '%' }"></span>
          </p>
        </div>
      </div>
      <zsFilePreview :fileList="uploadedFileList" v-bind="attrsCopy" :isView="isDisabled" @on-remove="handleRemove"/>
    </template>
    <el-form v-else :disabled="false">
      <zsFilePreview :fileList="uploadedFileList" v-bind="attrsCopy" :isView="isDisabled" @on-remove="handleRemove"/>
    </el-form>
  </div>
</template>

<script>
import zsFilePreview from './zsFilePreview'
import { isEqual, cloneDeep } from 'lodash-es'
import store from '@/store'
import config from '@/config/config'
import request from '@/service'
// import Bus from '@/utils/bus.js'
import { ZlLoading } from 'truelore-public/lib/zl-loading'
export default {
  components: { zsFilePreview },
  props: {
    drag: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    fileSize: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 20
    },
    isNeedFuGai: {
      type: Boolean,
      default: false
    },
    // 查看隐藏上传按钮
    isDisabled: {
      type: Boolean,
      default: false
    },
    // v-model 绑定groupId
    value: {
      type: String,
      default: ''
    },
    // 是否需要重新生成文件groupId
    needNewGroup: {
      type: Boolean,
      default: false
    },
    locationGuid: {
      type: String,
      default: ''
    },
    // 是否需要显示接收文件类型
    isNeedAccetpText: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: true,
      attrsCopy: {},
      fileList: [],
      // 已上传文件列表，防止未上传完成点击预览
      uploadedFileList: [],
      progressFlag: false,
      progressPercent: 0,
      fileName: '',
      uploadingArr: [],
      fileTypes: '',
      showFileTypesData: ''
    }
  },
  watch: {
    /* uploadingArr(val) {
      Bus.$emit('changeFileUploading')
    }, */
    $attrs: {
      handler(newVal, value) {
        if (!isEqual(newVal, value)) {
          this.attrsCopy = cloneDeep(newVal)
        }
      },
      immediate: true
    },
    // groupId改变则进行文件列表请求
    value: {
      immediate: true,
      handler(n, o) {
        this.getFileList(n)
        // if (n) {
        //   if (!o) {
        //   }
        // }
      }
    },
    locationGuid: {
      handler(val) {
        if (val) {
          this.getCurrentSuffix()
        }
      },
      immediate: true
    }
  },
  computed: {
    uploaderId() {
      return 'filePicker_' + new Date().getTime()
    }
  },
  /* mounted() {
    Bus.$on('isDestroyUploader', (val) => {
      let uploadingArr = store.state.uploadingArr
      if (uploadingArr && uploadingArr.length) {
        uploadingArr.map((uit) => {
          uit.status = false
        })
      }
    })
  }, */
  methods: {
    handleChange(file, fileList) {
      this.fileList = fileList
    },
    // 文件预览
    handlePreview(file) {
      store
        .dispatch('getFileToken', {
          type: 2,
          bindType: 1,
          bindGuid: file.guid
        })
        .then((res) => {
          // 下载文件
          window.open(
            `${config.fileDownUrl}/zsj-file-server/token/downloadFile?guid=${file.guid}&token=${res.data}`
          )
        })
    },
    // 文件删除的回调
    async handleRemove(file, fileList) {
      let fileId = ''
      this.fileList = fileList
      this.uploadedFileList = fileList
      if (fileList.length) {
        // 重新生成文件组
        await store
          .dispatch('generateFileNewGroup', {
            fileInfoGuidList: fileList.map((t) => t.guid)
          })
          .then((res) => {
            if (res.success) {
              fileId = res.data
            }
          })
      }
      this.$emit('input', fileId)
    },
    // 获取已上传文件
    getFileList(groupGuid) {
      if (groupGuid) {
        store
          .dispatch('getFileToken', {
            type: 2,
            bindType: 2
          })
          .then((res) => {
            store
              .dispatch('getFileInfoByGroup', {
                token: res.data,
                groupGuid
              })
              .then((res) => {
                if (res.data && res.data.length > 0) {
                  this.fileList = []
                  this.uploadedFileList = []
                  res.data.forEach((file) => {
                    this.fileList.push({
                      name: file.name,
                      guid: file.guid,
                      createTime: file.createTime
                    })
                    this.uploadedFileList.push({
                      name: file.name,
                      guid: file.guid,
                      createTime: file.createTime
                    })
                    this.show = false
                    this.$nextTick(() => {
                      this.show = true
                    })
                  })
                }
              })
          })
      } else {
        this.fileList = []
        this.uploadedFileList = []
      }
    },
    beforeUpload(file) {
      if (this.fileSize) {
        if (file.size / 1024 / 1024 > this.fileSize) {
          this.$message({
            message: `只能上传小于${this.fileSize}M的文件！`,
            type: 'warning'
          })
          return false
        } else if (this.fileTypes) {
          const pickedFileName = file.name.substring(file.name.lastIndexOf('.'))
          const extension = this.fileTypes ? this.fileTypes.split(',').map(item => item.toLowerCase()).indexOf(pickedFileName.toLowerCase()) !== -1 : false
          if (!extension) {
            this.$message({
              message: `只能上传${this.fileTypes}格式的文件！`,
              type: 'warning'
            })
            return false
          }
          return true
        } else {
          return true
        }
      } else if (this.fileTypes) {
        const pickedFileName = file.name.substring(file.name.lastIndexOf('.'))
        const extension = this.fileTypes ? this.fileTypes.split(',').map(item => item.toLowerCase()).indexOf(pickedFileName.toLowerCase()) !== -1 : false
        if (!extension) {
          this.$message({
            message: `只能上传${this.fileTypes}格式的文件！`,
            type: 'warning'
          })
          return false
        }
        return true
      } else {
        return true
      }
    },
    handleExceed() {
      this.$message({
        message: `上传数量最大为${this.limit}!`,
        type: 'warning'
      })
    },
    // 上传文件
    uploadFile(params) {
      console.log('params', params)
      console.log('this.progressPercent 111', this.progressPercent)
      this.progressFlag = true
      this.fileName = params.file.name
      this.progressPercent = 0
      ZlLoading.show()
      let self = this
      store
        .dispatch('getFileToken', {
          type: 1,
          bindType: 1
        })
        .then((res) => {
          let formData = new FormData()
          formData.append('file', params.file)
          // this.fileList.forEach((item) => {
          //   formData.append('file', item.raw)
          // })
          // console.log(formData.getAll('file'))
          /* store
            .dispatch('upload', {
              groupGuid:
                this.value === null || this.value === 'null' ? '' : this.value,
              token: res.data,
              file: formData
            })
            .then((res2) => {
              this.$emit('input', res2.data.groupGuid)
              const exist = this.fileList.find((t) => t.uid === params.file.uid)
              this.uploadedFileList = this.fileList
              if (exist) {
                exist.guid = res2.data.guid
              }
              if (this.value) {
                this.getFileList(this.value)
              }
            }) */
          /* let uploadingArr = store.state.uploadingArr
          if (uploadingArr && uploadingArr.length) {
            this.uploadingArr = uploadingArr
          }
          if (this.uploadingArr && this.uploadingArr.length) {
            this.uploadingArr = [...this.uploadingArr, { id: this.uploaderId, status: true }]
          } else {
            this.uploadingArr.push({ id: this.uploaderId, status: true })
          }
          store.commit('setState', {
            key: 'uploadingArr',
            value: this.uploadingArr
          })
          this.$emit('getUploadId', this.uploaderId) */
          console.log('this.progressPercent 222', this.progressPercent)
          let groupGuid = this.isNeedFuGai
            ? ''
            : this.value === null || this.value === 'null'
              ? ''
              : this.value
          // 如果需要重新生成groupId
          if (this.needNewGroup && this.fileList.length > 1) {
            groupGuid = ''
          }
          request.post(
            `/file/zsj-file-server/token/upload?groupGuid=${groupGuid}&token=${res.data}`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data;charset=utf-8'
              },
              onUploadProgress: progressEvent => {
                this.progressPercent = Number(((progressEvent.loaded / progressEvent.total) * 100).toFixed(2))
                console.log('this.progressPercent 333', this.progressPercent)
              }
            }
          ).then(res2 => {
            ZlLoading.close()
            this.progressFlag = false
            const exist = this.fileList.find((t) => t.uid === params.file.uid)
            this.uploadedFileList = this.fileList
            if (exist) {
              exist.guid = res2.data.guid
            }
            // 文件列表大于1个时，重新生成文件组id
            if (this.needNewGroup && this.fileList.length > 1) {
              store
                .dispatch('generateFileNewGroup', {
                  fileInfoGuidList: this.fileList.map((t) => t.guid)
                })
                .then((res) => {
                  if (res.success) {
                    this.$emit('input', res.data)
                  }
                })
            } else {
              this.$emit('input', res2.data.groupGuid)
              if (this.value && !this.isNeedFuGai) {
                this.getFileList(this.value)
              }
            }
            /* this.uploadingArr.forEach((item) => {
              if (item.id === self.uploaderId) {
                item.status = false
              }
            }) */
          }).catch(() => {
            this.progressFlag = false
            ZlLoading.close()
          })
        })
        .catch(() => {
          this.progressFlag = false
          ZlLoading.close()
        })
    },
    uniqueStrings(str, symbol) {
      // 将字符串转换为数组，并用逗号分隔
      const stringArray = str.split(symbol)
      // 使用Set去重，再转换回数组
      const uniqueSet = new Set(stringArray)
      // 将Set转换回数组并返回
      return [...uniqueSet].join(symbol)
    },
    // 获取当前位置上传组件配置的后缀类型  参数为 位置guid
    async getCurrentSuffix() {
      store
        .dispatch('queryFuJianHouZhuiByWeiZhiId', {
          fuJianWeiZhiGuid: this.locationGuid
        }).then((res) => {
          if (res.success && res.data) {
            this.fileTypes = res.data.replace(/、/g, ',')
            const str = res.data.replace(/,/g, '、')
            this.showFileTypesData = this.uniqueStrings(str, '、')
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.zsUpload {
  .uploading-icon {
    display: inline-block;
    width: 40px;
    background: url('../../src/assets/images/fileloading.gif') center no-repeat;
  }
  p {
      padding: 5px;
      width: 100%;
      display: flex;
      position: relative;
      &:hover {
          background: #eee;
      }
      .icon-hbyzhengque {
          color: yellowgreen;
      }
      .icon-wenjian {
          color: #ccc;
          margin-right: 10px;
          padding-bottom: 5px;
      }
      .icon-chuyidong {
          font-size: 16px;
      }
      .progressBar {
          width: 100%;
          height: 0;
          position: absolute;
          bottom: 0;
          left: 0;
          display: inline-block;
          border-radius: 90px;
          border-bottom: 7px solid #eaedf4;
      }
      .progressBarMove {
          width: 0;
          height: 0;
          position: absolute;
          bottom: 0;
          left: 0;
          display: inline-block;
          border-radius: 90px;
          border-bottom: 7px solid #ffa426;
      }
      .progressBarSuc {
          width: 100%;
          height: 0;
          position: absolute;
          bottom: 0;
          left: 0;
          display: inline-block;
          border-bottom: 2px solid yellowgreen;
      }
      .fileName {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

      }
      .fileTime {
          display: inline-block;
          width: 150px;
          text-align: right;
          text-indent: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #f7aa4f;
      }
      .iconSvg {
          width:35px;
          color: #666;
          .pdfLoad {
              margin-right: 5px;
          }
      }
  }
  .acceptMsg {
    color:rgba(0, 0, 0, 0.45);
  }
}
</style>
